module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_header_2-41d8f7e80609d04d47290016cec5bdab.jpg";